import { apiInterceptor } from 'utils/apiInterceptor';
/**
 * Get all projects for Livestream
 */
export async function updateStreamUserRole(projectId, offset = 0, showcaseId) {
    const headers = {
        'Content-Type': 'application/json',
    };

    let payload = {
        offset,
    };

    if (showcaseId) payload.sponsorChannelId = showcaseId;

    const response = await apiInterceptor(
        `${process.env.REACT_APP_MYXP_API}/manager/livestream/stream/${projectId}/assign`,
        {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload),
        }
    );

    return await response.json();
}

export async function truncateAllMessages({ projectId, channelIds = null }) {
    const headers = {
        'Content-Type': 'application/json',
    };

    let options = {
        method: 'POST',
        headers: headers,
    };

    if (channelIds) options.body = JSON.stringify({ channelIds });

    const response = await apiInterceptor(
        `${process.env.REACT_APP_MYXP_API}/manager/livestream/stream/${projectId}/truncate-channels`,
        options
    );

    return await response.json();
}
